"use strict";
// @ts-nocheck
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.productsSelector = exports.useTagsSelector = exports.useTagCloudSelector = exports.tagCloudSelector = exports.useTagsSidebarSelector = exports.tagsSidebarSelector = exports.tagsSelector = exports.ownDesignAllowedSelector = exports.authenticityTokenSelector = exports.isMobileSelector = exports.paginationSelector = exports.buyInOneClickSelector = exports.productsMapSelector = exports.useSortSelector = exports.sortSelector = exports.rootPathSelector = exports.useFiltersSelector = exports.filtersSelector = exports.filtersMapSelector = exports.tagsMapSelector = exports.pathSelector = exports.faqSelector = exports.advantagesSelector = exports.useSeoTypeSelector = exports.seoTypeSelector = exports.useCategoriesSelector = exports.categoriesSelector = exports.breadcrumbsSelector = void 0;
var react_redux_1 = require("react-redux");
var reselect_1 = require("reselect");
var createPathByFilters_1 = __importDefault(require("../utils/createPathByFilters"));
var tree_1 = __importDefault(require("../utils/tree"));
var breadcrumbsSelector = function (state) { return state.seo.breadcrumbs; };
exports.breadcrumbsSelector = breadcrumbsSelector;
var categoriesSelector = function (state) {
    return new tree_1.default(state.categories);
};
exports.categoriesSelector = categoriesSelector;
var useCategoriesSelector = function () { return (0, react_redux_1.useSelector)(exports.categoriesSelector); };
exports.useCategoriesSelector = useCategoriesSelector;
var seoTypeSelector = function (state, type) { return state.seo[type]; };
exports.seoTypeSelector = seoTypeSelector;
var useSeoTypeSelector = function (type) {
    return (0, react_redux_1.useSelector)(function (state) { return (0, exports.seoTypeSelector)(state, type); });
};
exports.useSeoTypeSelector = useSeoTypeSelector;
var advantagesSelector = function (state) { return state.seo.advantages; };
exports.advantagesSelector = advantagesSelector;
var faqSelector = function (state) { return state.seo.faq; };
exports.faqSelector = faqSelector;
var pathSelector = function (state) { return state.path; };
exports.pathSelector = pathSelector;
var tagsMapSelector = function (state) { return state.tags; };
exports.tagsMapSelector = tagsMapSelector;
var filtersMapSelector = function (state) { return state.filters; };
exports.filtersMapSelector = filtersMapSelector;
var filtersSelector = function (state, isCustomStore) {
    var filters = state.filters;
    var rootPath = filters.rootPath, department = filters.department, category = filters.category, type = filters.type;
    var combineList = isCustomStore
        ? [department, category, type]
        : [rootPath, department, category, type];
    var combine = filters.combine;
    combine =
        combine ||
            combineList.reduce(function (acc, i) {
                if (i) {
                    return "".concat(acc, "/").concat(i);
                }
                return acc;
            });
    return {
        rootPath: rootPath,
        combine: combine,
        cod: filters.ownDesignPath,
        tag: filters.tag || '',
        subTag: filters.subTag || '',
        page: filters.page,
        search: filters.search,
        sort: filters.sort,
        price: filters.price || { min: null, max: null },
        loading: filters.loading,
        loaded: filters.loaded,
    };
};
exports.filtersSelector = filtersSelector;
var useFiltersSelector = function (isCustomStore) {
    return (0, react_redux_1.useSelector)(function (state) { return (0, exports.filtersSelector)(state, isCustomStore); });
};
exports.useFiltersSelector = useFiltersSelector;
var rootPathSelector = function (state) { return state.filters.rootPath; };
exports.rootPathSelector = rootPathSelector;
var sortSelector = function (state) { return state.sort; };
exports.sortSelector = sortSelector;
var useSortSelector = function () { return (0, react_redux_1.useSelector)(exports.sortSelector); };
exports.useSortSelector = useSortSelector;
var productsMapSelector = function (state) { return state.products; };
exports.productsMapSelector = productsMapSelector;
var buyInOneClickSelector = function (state) { return state.buyInOneClick; };
exports.buyInOneClickSelector = buyInOneClickSelector;
var paginationSelector = function (state) { return state.pagination; };
exports.paginationSelector = paginationSelector;
var isMobileSelector = function (state) { return state.isMobile; };
exports.isMobileSelector = isMobileSelector;
var authenticityTokenSelector = function (state) {
    return state.authenticityToken;
};
exports.authenticityTokenSelector = authenticityTokenSelector;
var ownDesignAllowedSelector = function (state) {
    return state.ownDesignAllowed;
};
exports.ownDesignAllowedSelector = ownDesignAllowedSelector;
exports.tagsSelector = (0, reselect_1.createSelector)(exports.tagsMapSelector, exports.filtersSelector, function (tags, filters) {
    return tags.map(function (tag) {
        return __assign(__assign({}, tag), { path: (0, createPathByFilters_1.default)(filters, {
                tag: tag.parametrazedName,
                subTag: "",
                page: 1,
            }), children: tag.children.map(function (subTag) {
                return __assign(__assign({}, subTag), { path: (0, createPathByFilters_1.default)(filters, {
                        tag: tag.parametrazedName,
                        subTag: subTag.parametrazedName,
                        page: 1,
                    }), active: subTag.parametrazedName === filters.subTag });
            }), active: tag.parametrazedName === filters.tag });
    });
});
exports.tagsSidebarSelector = (0, reselect_1.createSelector)(exports.tagsSelector, function (tags) {
    var featured = [];
    var normal = [];
    var hidden = [];
    tags.forEach(function (tag) {
        if (tag.position < 10) {
            featured.push(tag);
        }
        else if (tag.position < 100) {
            normal.push(tag);
        }
        else if (tag.position > 99) {
            hidden.push(tag);
        }
    });
    return {
        featured: featured,
        normal: normal,
        hidden: hidden,
    };
});
var useTagsSidebarSelector = function () { return (0, react_redux_1.useSelector)(exports.tagsSidebarSelector); };
exports.useTagsSidebarSelector = useTagsSidebarSelector;
exports.tagCloudSelector = (0, reselect_1.createSelector)(exports.tagsSelector, function (tags) {
    return tags.reduce(function (acc, tag) {
        if (tag.active) {
            return __spreadArray([], tag.children, true);
        }
        return __spreadArray([], acc, true);
    }, []);
});
var useTagCloudSelector = function () { return (0, react_redux_1.useSelector)(exports.tagCloudSelector); };
exports.useTagCloudSelector = useTagCloudSelector;
var useTagsSelector = function () { return (0, react_redux_1.useSelector)(exports.tagsSelector); };
exports.useTagsSelector = useTagsSelector;
var useTagsSidebarSelector = function () { return (0, react_redux_1.useSelector)(exports.tagsSidebarSelector); };
exports.useTagsSidebarSelector = useTagsSidebarSelector;
exports.productsSelector = (0, reselect_1.createSelector)(exports.productsMapSelector, function (products) { return products; });
